import gql from 'graphql-tag';

// The list of proof of address document types is embedded directly
// in this query in order to make it easier for the multiple locations
// that import the query for the purposes of refetching the POA status.
export const isMissingProofOfAddressQuery = gql`
  query IsMissingProofOfAddressQuery($companyProfileId: ID!) {
    viewer {
      uid
      companyUser(companyProfileId: $companyProfileId) {
        companyUserId
        proofOfAddressDocuments: kycDocuments(
          types: [
            "PROOF_OF_ACCOMMODATION"
            "PROOF_OF_ADDRESS_HOST"
            "PASSPORT_HOST"
            "ID_RECTO_HOST"
            "ID_VERSO_HOST"
            "RESIDENCE_PERMIT_RECTO_HOST"
            "RESIDENCE_PERMIT_VERSO_HOST"
            "PROOF_OF_ADDRESS"
          ]
        ) {
          kycDocumentId
          status
          updatedAt
        }
      }
    }
  }
`;
